export default "__VITE_ASSET__Dkut2juo__"